import React from "react";
import { useTranslation } from "react-i18next";

// Names by position/order, not by employee-count value
const packageNamesByIndex = [
  { ar: "الباقة الأساسية", en: "Basic Package" },
  { ar: "الباقة المتقدمة", en: "Advanced Package" },
  { ar: "باقة الشركات", en: "Enterprise Package" },
];

const PlanTabs = ({ active, setActive, plans = [] }) => {
  const { i18n } = useTranslation();
  const isAR = i18n.language?.startsWith("ar");

  const tabs = Array.isArray(plans) && plans.length ? plans : [20, 50, 100];

  if (!tabs.length) return null;

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 rounded-xl bg-gray-200 p-1">
      {tabs.map((p, index) => {
        const name = packageNamesByIndex[index];
        const isActive = active === p;

        return (
          <button
            key={p}
            type="button"
            onClick={() => setActive(p)}
            className={`cursor-pointer rounded-lg px-4 py-1 text-lg whitespace-nowrap transition ${
              isActive ? "text-primary bg-white shadow" : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {name ? name[isAR ? "ar" : "en"] : `${p}+`}
          </button>
        );
      })}
    </div>
  );
};

export default PlanTabs;